import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiPhone, FiCalendar } = FiIcons;

export default function CallModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm">
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[100vh] overflow-y-auto flex flex-col md:flex-row relative animate-in fade-in zoom-in duration-200"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 bg-white/80 hover:bg-slate-100 rounded-full text-slate-500 hover:text-slate-700 transition-colors"
          aria-label="Close modal"
        >
          <SafeIcon icon={FiX} className="text-xl" />
        </button>

        {/* Options Panel */}
        <div className="p-8 md:w-1/3 bg-slate-50 flex flex-col justify-center border-r border-slate-100">
          <h2 className="text-2xl font-black text-[#5E3A21] mb-2">Connect With Us</h2>
          <p className="text-slate-500 mb-8 text-sm">Choose how you'd like to get in touch. We're here to help you heal holistically.</p>

          <div className="space-y-4">
            <a
              href="tel:678-378-7905"
              className="flex items-center gap-4 w-full p-4 bg-white border-2 border-slate-100 rounded-xl hover:border-[#005b2d] hover:shadow-md transition-all group"
            >
              <div className="w-12 h-12 bg-green-50 text-[#005b2d] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                <SafeIcon icon={FiPhone} className="text-xl" />
              </div>
              <div className="text-left">
                <div className="font-bold text-slate-800">Call Now</div>
                <div className="text-sm text-slate-500">Speak with us directly</div>
              </div>
            </a>

            <div className="flex items-center gap-4 w-full p-4 bg-white border-2 border-[#005b2d] rounded-xl shadow-sm relative overflow-hidden">
              <div className="absolute inset-0 bg-green-50/50"></div>
              <div className="w-12 h-12 bg-[#005b2d] text-white rounded-full flex items-center justify-center relative z-10">
                <SafeIcon icon={FiCalendar} className="text-xl" />
              </div>
              <div className="text-left relative z-10">
                <div className="font-bold text-[#005b2d]">Book a Call</div>
                <div className="text-sm text-slate-600">Select a time on our calendar</div>
              </div>
            </div>

            <a
              href="https://calendar.app.google/dh6SNXxpFN8eeH6x9"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center text-sm text-[#005b2d] hover:underline mt-4 md:hidden"
            >
              Calendar not loading? Open in new tab
            </a>
          </div>
        </div>

        {/* Calendar Embed Panel */}
        <div className="md:w-2/3 h-[500px] md:h-[600px] bg-white relative">
          <iframe
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3CDjoS4D2zfXHlNiHgIdxXoCmZ4neGuwKq5rqhHqRFnq44c3dw3eDaLfjs179NHV54hDhXmD2a?gv=true"
            style={{ border: 0 }}
            width="100%"
            height="100%"
            frameBorder="0"
            className="w-full h-full"
            title="Book a Call"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
